export const heroSlides = [
  {
    prefix: 'Join Elite Scholars',
    // Was "Top 1%": a claim with no evidence behind it (ARB Code), removed
    // 2026-10-07. Factual, unquantified copy only until there is data.
    title: 'Vetted Tutors',
    description: 'Join our vetted tutors helping CAPS, IEB and Cambridge learners master key subjects, prepare for exams, and reach their goals - online or in-person.',
    button: 'View Elite Scholars Careers',
    href: '/careers'
  },
  {
    prefix: 'University',
    title: 'Semester Test & Exam Prep',
    description: 'Get personalized tutoring, past paper practice, and expert support from university-level tutors. Book your session today and improve your results.',
    button: 'View Exam Prep Services',
    href: '/our-services'
  },
  {
    prefix: 'University',
    title: 'Exam Preparation',
    description: 'Prepare for exams with Elite Scholars! Our expert tutors offer personalized one-on-one, online and contact sessions, tailored to help you succeed in university exams.',
    button: 'Explore Our Services',
    href: '/our-services'
  },
  {
    prefix: 'Personalized',
    title: 'Tutoring',
    description: "Whether you're in primary school, high school, or university, we offer expert guidance that meets your unique learning needs.",
    button: 'Explore Tutoring Services',
    href: '/our-services/tutoring-service'
  }
];
